import React from "react";
import { createRoot } from "react-dom/client";
import { CloudflareApp } from "./cloudflare/CloudflareApp";
import "./cloudflare/index.css";

function showFatalError(cause: unknown) {
  const target = document.getElementById("root");
  if (!target || target.dataset.fatalError === "true") return;
  target.dataset.fatalError = "true";
  const main = document.createElement("main");
  main.className = "not-found page-shell fatal-error";
  const label = document.createElement("span");
  label.textContent = "OFF AIR";
  const heading = document.createElement("h1");
  heading.textContent = "Jamband hit a bad frequency.";
  const detail = document.createElement("p");
  detail.textContent = import.meta.env.DEV && cause instanceof Error
    ? cause.message
    : "Reload the page to reconnect.";
  const reload = document.createElement("button");
  reload.className = "button primary";
  reload.textContent = "Reload Jamband";
  reload.addEventListener("click", () => window.location.reload());
  main.append(label, heading, detail, reload);
  target.replaceChildren(main);
}

function start() {
  const target = document.getElementById("root");
  if (!target) throw new Error("Missing Jamband root element");
  createRoot(target).render(<React.StrictMode><CloudflareApp /></React.StrictMode>);
}

window.addEventListener("error", (event) => showFatalError(event.error));
window.addEventListener("unhandledrejection", (event) => showFatalError(event.reason));

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    try { start(); } catch (cause) { showFatalError(cause); }
  });
} else {
  try { start(); } catch (cause) { showFatalError(cause); }
}
